module.exports = __webpack_public_path__ + "img/num_31.3a668629.png";